module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/banner_movie@3x-a23f399682a58a41046c52cd263fd49d.webp";